import { render } from "./THticket.vue?vue&type=template&id=acc89e04&scoped=true"
import script from "./THticket.vue?vue&type=script&lang=js"
export * from "./THticket.vue?vue&type=script&lang=js"

import "./THticket.vue?vue&type=style&index=0&id=acc89e04&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acc89e04"]])

export default __exports__